import heroLines from "@/assets/hero-lines-white.webp";

// Фирменный фон: еле видимое лицо + золотые линии золотого сечения с дышащим свечением.
// Линии: белое webp с альфа-каналом используется как маска над золотым градиентом.
export const FaceTexture = () => (
  <div aria-hidden="true" className="pointer-events-none fixed inset-0 z-0">
    <img
      src="/images/hero-face-dim.jpg"
      alt=""
      className="h-full w-full object-cover object-[50%_18%] opacity-[0.07]"
      style={{
        WebkitMaskImage: "linear-gradient(to bottom, transparent, black 12%, black 88%, transparent)",
        maskImage: "linear-gradient(to bottom, transparent, black 12%, black 88%, transparent)",
      }}
    />
    <div
      className="mask-glow absolute inset-0 opacity-[0.12]"
      style={{
        background: "linear-gradient(160deg, #EBD096 0%, #C2A878 45%, #8A744A 100%)",
        WebkitMaskImage: `url(${heroLines})`,
        maskImage: `url(${heroLines})`,
        WebkitMaskSize: "cover",
        maskSize: "cover",
        WebkitMaskPosition: "50% 18%",
        maskPosition: "50% 18%",
      }}
    />
    <div className="absolute -bottom-24 -right-24 h-[420px] w-[420px] rounded-full bg-[#C2A878]/[0.07] blur-[130px]" />
    <div className="absolute -left-32 top-1/3 h-[360px] w-[360px] rounded-full bg-[#C2A878]/[0.05] blur-[120px]" />
    {/* мягкое затемнение верха — чтобы заголовки не тонули в светлых линиях текстуры */}
    <div className="absolute inset-x-0 top-0 h-[38%] bg-gradient-to-b from-[#0A0A0A]/55 via-[#0A0A0A]/20 to-transparent" />
  </div>
);
